import {useEffect} from 'react'
import {useParams} from 'react-router-dom'

import useFetch from 'shared/model/useFetch'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'

const usePostEarlyDecrease = () => {
	const {idx} = useParams()

	const [fetchResult, fetchRequest] = useFetch()
	const [, setAlert] = useAlertModalAtom()

	const request = (numberOfEarly = 1) => {
		let url = `/admin/timer/early/decrease`

		fetchRequest('POST', url, {
			event_idx: idx,
			number_of_early: numberOfEarly,
		})
	}

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 400:
				if (fetchResult?.data?.error_code === 1) {
					setAlert('아직 대회가 시작되지 않았습니다.')
				} else {
					setAlert(fetchResult?.data?.message || '문제가 발생했습니다.')
				}
				break
			case 404:
				if (fetchResult?.data?.error_code === 1) {
					setAlert('대회 데이터가 존재하지 않습니다.')
				} else {
					setAlert(fetchResult?.data?.message || '문제가 발생했습니다.')
				}

				break
			default:
				break
		}
	}, [fetchResult])

	return [request]
}

export default usePostEarlyDecrease
